export default __webpack_public_path__ + "static/media/computer.8afd5e87.svg";